import { Box, Button, Stack, Typography } from '@mui/material'
import { AddCircleOutline } from '@mui/icons-material'
import { com } from '@eidu/web'
import { PermissionWithId } from '../input/PermissionsInput'
import PermissionEditorRow from './PermissionEditorRow'
import { ColDef, EntityRow } from './utils'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import Permission = com.eidu.sharedlib.entity.permission.Permission

type CellEditorProps = {
  row: EntityRow
  col: ColDef
  permissions: readonly PermissionWithId[]
  entityTypes: readonly EntityType[]
  allowsPath: boolean
  userEntityTypeId: EntityTypeId | undefined
  onAdd: () => void
  onReplace: (id: string, permission: Permission) => void
  onDelete: (id: string) => void
}

const CellEditor = ({
  row,
  col,
  permissions,
  entityTypes,
  allowsPath,
  userEntityTypeId,
  onAdd,
  onReplace,
  onDelete,
}: CellEditorProps) => (
  <Stack spacing={1}>
    <Stack direction="row" alignItems="center" spacing={1}>
      <col.Icon fontSize="small" />
      <Typography variant="subtitle2">
        {col.label} — {row.label}
      </Typography>
    </Stack>
    <Stack spacing={1}>
      {permissions.map((p) => (
        <PermissionEditorRow
          key={p.id}
          permission={p.permission}
          allowsPath={allowsPath}
          userEntityTypeId={userEntityTypeId}
          entityTypes={entityTypes}
          rowEntityTypeId={row.entityTypeId}
          action={col.action}
          onChange={(newPerm) => onReplace(p.id, newPerm)}
          onDelete={() => onDelete(p.id)}
        />
      ))}
    </Stack>
    <Box>
      <Button size="small" startIcon={<AddCircleOutline />} onClick={onAdd}>
        Add another
      </Button>
    </Box>
  </Stack>
)

export default CellEditor
